import { Button, DismissIcon, Flex, MenuIcon, Modal } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useState } from 'react';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { trackHeaderTap } from '@jane/bloom/services/tracking/track';

import styles from './mainMenu.module.css';
import { MainMenuItems } from './mainMenuItems';

export function MainMenu() {
  const [open, setOpen] = useState(false);
  const [transition, setTransition] = useState('');
  const { featureFlags, logo, pinnedStore, shoppingPreferences, theme } =
    useRootLoaderData();

  const mainMenuItems = theme.bloom?.main_menu;

  const toggleMainMenu = () => {
    if (!open) {
      setOpen(true);
      setTimeout(() => {
        setTransition('main-menu-modal--on-enter');
      }, 50);
    } else {
      setTransition('main-menu-modal--on-exit');
      setTimeout(() => {
        setOpen(false);
      }, 500);
    }
  };

  return (
    <div className="focus-visible">
      <Button.Icon
        label="Main menu"
        icon={<MenuIcon color="text-main" />}
        type="button"
        variant="minimal"
        className={styles['menuIcon']}
        onClick={() => {
          toggleMainMenu();
          trackHeaderTap(
            {
              reservationMode: shoppingPreferences?.reservationMode,
              tappable: 'hamburger menu',
            },
            featureFlags
          );
        }}
      />
      <ClientOnly>
        {() => (
          <Modal
            background="grays-white"
            open={open}
            onRequestClose={() => toggleMainMenu()}
            className={clsx(styles['mainMenuModal'], `${transition}`)}
            variant="full-screen"
            overlayClassName="darkened-overlay"
            overlayClose
          >
            <Modal.Content padding={false}>
              <Flex className={styles['mainMenuHeader']}>
                {logo?.xsmall && (
                  <div className={styles['logoContainer']}>
                    <img
                      src={logo.xsmall}
                      alt={pinnedStore?.name ?? 'store logo'}
                      loading="eager"
                    />
                  </div>
                )}
                <Flex className={styles['dismissIconContainer']}>
                  <DismissIcon
                    altText="Dismiss modal"
                    onClick={() => toggleMainMenu()}
                    className={styles['dismissIcon']}
                  />
                </Flex>
              </Flex>
              <MainMenuItems items={mainMenuItems} />
            </Modal.Content>
            <Modal.Footer className={styles['mainMenuFooter']}>
              <Button
                full
                label="Close"
                className={styles['closeButton']}
                onClick={() => toggleMainMenu()}
              />
            </Modal.Footer>
          </Modal>
        )}
      </ClientOnly>
    </div>
  );
}
